/**
 * Helpers.js
 * Consists of standalone generic functions to use througout the application.
 */

/**
 * Short file name string
 * @param {String} string
 * @param {Number} length
 * @returns {String}
 */
export const shortenFileString = (string, length) => {
  if (string.length <= length) {
    return string
  }
  const reversedString = string.split('').reverse().join('')
  const findExtension = reversedString.substring(
    0,
    reversedString.indexOf('.') + 1
  )
  const extension = findExtension.split('').reverse().join('')

  return string.substring(0, length) + ' ... ' + extension
}

// https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
// Usage : escape special characters -> +47 = \+47
const escapeSpecialChars = (string) => {
  return string.replace(/[.*+?<>^${}()|[\]\\]/g, '\\$&')
}

export const highlightContains = (needle, haystack) => {
  const escapedNeedle = escapeSpecialChars(needle)
  const regex = new RegExp(`${escapedNeedle}`, 'gi')
  const isMatch = regex.test(haystack)
  const highlight = isMatch
    ? haystack.replace(regex, (str) => `<mark>${str}</mark>`)
    : null

  const result = {
    match: isMatch,
    item: haystack,
    highlight,
  }
  return result
}

export const generateRolesPerFlags = (flags) => {
  return [
    {
      actions: ['read', 'delete', 'create', 'update'],
      subject: flags,
    },
  ]
}

export const getUniqueFlags = (flags) => {
  return flags.filter((item, index) => flags.indexOf(item) === index)
}
